<template>
    <v-form
            novalidate
            ref="form"
            v-model="valid"
            lazy-validation
    >
        <v-text-field
                v-model="pwd"
                :rules="pwdRules"
                label="Palavra-passe"
                required
                filled
                :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (value = !value)"
                :type="value ? 'password' : 'text'"
                :disabled="getDisabledButton"
        ></v-text-field>

        <v-text-field
                v-model="rePwd"
                :rules="pwdRules"
                label="Repetir Palavra-passe"
                required
                filled
                :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (value = !value)"
                :type="value ? 'password' : 'text'"
                :disabled="getDisabledButton"
        ></v-text-field>
        <input type="hidden" name="browser" value="">
        <input type="hidden" name="ip" value="">
        <v-card-actions>
            <!--            <submit-button :valid="valid"></submit-button>-->
            <v-btn
                    color="deep-purple lighten-2"
                    text
                    block
                    @click="submitLogin"
                    :disabled="!valid"
                    :loading = "getLoadingSpin"
            >
                Redefinir palavra passe
            </v-btn>
        </v-card-actions>
    </v-form>
</template>
<script>
    import { mapHelper } from "../../store/helper.js"
    import takeIp from "../../../services/takeIp";
    import jwtDecode from "jwt-decode";
    export default {
        name: "RecoverPassword",
        data: () => ({
            value: true,
            valid: true,
            access:true,
            pwd: '',
            rePwd: '',
            browser:'',
            pwdRules: [
                v => !!v || 'Palavra-passe é requerida',
                v => (v && v.length >= 6) || 'Deve ter no mínimo 6 caracter',
                v => /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W+)(?=^.{6,15}$).*$/.test(v) || 'Deve ter minúsculas, maísculas e caracter especial',
            ],
            username: '',
            emailRules: [
                v => !!v || 'Utilizador é requerido',
                v => /.+@.+\..+/.test(v) || 'Utilizador inválido',
            ],
        }),
        methods: {
            getParams() {
                const urlParams = new URLSearchParams(window.location.search);
                return (this.search = urlParams.get("kyami"));
            },
            submitLogin () {
                if(this.$refs.form.validate()){
                    const decode = jwtDecode(this.getParams());
                    if(this.pwd === this.rePwd){
                        this.$store.dispatch('recoverPassword',{
                            "email":decode.email,
                            "password":this.pwd,
                        })
                    }else{
                        return false;
                    }
                }
            },
            sleep:function(m){
                return new Promise((resolve => setTimeout(resolve, m)))
            },
            close(){
                return this.errorLogin = false
            },
        },
        mounted() {
            takeIp.getIpFromAmazon();
            takeIp.getNameBrowser()
        },
        computed:{
            ...mapHelper
        }
    }
</script>

<style scoped>

</style>